import React, { useEffect } from "react";
import { Layout, Row, Col } from "antd";
import { useDispatch } from "react-redux";

//component
import LayoutHeader from "screen/00_Nav/layout/layout_header";
import TriggerInit from "../trigger/trigger_init";
//action
import "./style.css";
import KycStepper from "./component/kyc_stepper";
import KycLayout from "./component/kyc_layout";
import { setHighlight } from "store/bailiff/nav/nav.action";

const { Content } = Layout;

const KycDetail = () => {
  // -------------------------- VAR --------------------------
  const title = "Tải lên Hồ Sơ";

  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  // -------------------------- FUNCTION --------------------------
  // -------------------------- EFFECT --------------------------
  useEffect(() => {
    dispatch(setHighlight(["1"]));
  }, [dispatch]);
  // -------------------------- RENDER --------------------------

  const renderStep = () => {
    return (
      <div
        style={{
          minHeight: 300,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: 30,
        }}
      >
        <KycStepper />
      </div>
    );
  };

  const renderForms = () => {
    return (
      <Row>
        <Col
          style={{ minHeight: 100, padding: 10 }}
          xl={24}
          lg={24}
          md={24}
          xs={24}
        >
          <KycLayout />
        </Col>
      </Row>
    );
  };

  const renderIntructions = () => {
    return <div></div>;
  };

  // -------------------------- MAIN --------------------------
  return (
    <Layout className="site-layout full">
      <LayoutHeader title={title} />
      <Content className="content">
        <Row
          style={{ paddingBottom: 100, overflow: "hidden" }}
          justify={"center"}
          gutter={[0, 30]}
        >
          <Col xl={5} lg={5} md={24} xs={24}>
            {renderStep()}
          </Col>
          <Col xl={12} lg={12} md={24} xs={24}>
            {renderForms()}
          </Col>
          <Col xl={7} lg={7} md={24} xs={24}>
            {renderIntructions()}
          </Col>
        </Row>
        {/* Dialog */}
        {/* Trigger */}
        <TriggerInit />
      </Content>
    </Layout>
  );
};

export default KycDetail;
